var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { FolderSettingModel } from '../types/folder-setting-model.interface';
import { FolderApi } from '../types/folder-api.interface';
let FolderSettingServiceImpl = class FolderSettingServiceImpl {
    constructor(_folderSettingModel, _folderApi) {
        this._folderSettingModel = _folderSettingModel;
        this._folderApi = _folderApi;
    }
    get folderSetting() {
        return this._folderSettingModel.folderSetting;
    }
    async initFolderSetting(params) {
        return this._folderApi.getFolderSettingApi(params).then((data) => {
            this.updateFolderSetting(data);
            return data;
        });
    }
    updateFolderSetting(folderSetting) {
        this._folderSettingModel.updateFolderSetting(folderSetting);
    }
    updateCollapseSetting(collapseSetting) {
        this._folderSettingModel.updateCollapseSetting(collapseSetting);
    }
    updateVisibleFields(visibleFields) {
        this._folderSettingModel.updateVisibleFields(visibleFields);
    }
    updateFreezeFields(freezeFields) {
        this._folderSettingModel.updateFreezeFields(freezeFields);
    }
    updateFilterFields(filterFields) {
        this._folderSettingModel.updateFilterFields(filterFields);
    }
    updateCurrentSort(currentSort) {
        this._folderSettingModel.updateCurrentSort(currentSort);
    }
    clearFolderSetting() {
        this._folderSettingModel.clearFolderSetting();
    }
    subscribe(callback) {
        return this._folderSettingModel.subscribe(callback);
    }
};
FolderSettingServiceImpl = __decorate([
    injectable(),
    __param(0, inject(FolderSettingModel)),
    __param(1, inject(FolderApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof FolderSettingModel !== "undefined" && FolderSettingModel) === "function" ? _a : Object, typeof (_b = typeof FolderApi !== "undefined" && FolderApi) === "function" ? _b : Object])
], FolderSettingServiceImpl);
export { FolderSettingServiceImpl };
